<div
  class="tw-p-6 tw-card tw-h-full tw-flex tw-flex-col tw-relative tw-transition tw-duration-300"
  [ngClass]="destacado ? 'tw-bg-[#F67011]' : 'tw-bg-white'"
  (mouseenter)="destacado = true"
  (mouseleave)="destacado = false"
>
  <div class="tw-px-4 tw-flex-1 tw-flex tw-flex-col">

    <!-- Ícono centrado y responsivo -->
    <div class="tw-flex">
      <i
        [ngClass]="icono"
        class="tw-text-4xl md:tw-text-5xl lg:tw-text-6xl tw-transition tw-duration-300"
        [class.tw-text-black]="destacado"
        [class.tw-text-[#F67011]]="!destacado"
      ></i>
    </div>

    <!-- Título -->
    <div class="tw-mt-4">
      <h3
        class="tw-text-xl md:tw-text-2xl tw-font-bold tw-text-pretty tw-transition tw-duration-300"
        [ngClass]="destacado ? 'tw-text-black' : 'tw-text-[#F67011] '"
      >
        {{ title }}
        <span [ngClass]="destacado ? 'tw-text-white' : 'tw-text-black'">
          {{ subTitle }}
        </span>
      </h3>
    </div>

    <!-- Texto -->
    <p
      class="tw-mt-2 tw-text-sm md:tw-text-base tw-text-justify tw-transition tw-duration-300"
      [ngClass]="[
        'tw-text-gray-700',
        destacado ? 'tw-text-white' : 'tw-text-black'
      ]"
    >
      {{ text }}
    </p>

    <!-- Espacio para el botón -->
    <div class="tw-h-24"></div>

    <!-- Botón fijo, centrado y responsivo -->
    <div class="tw-absolute tw-bottom-4 tw-left-0 tw-right-0 tw-flex tw-justify-center">
      <button
        (click)="openWhatsApp()"
        type="button"
        class="tw-px-5 md:tw-px-6 tw-py-2 tw-rounded-md tw-font-semibold tw-space-x-2 tw-text-sm md:tw-text-base tw-transition tw-duration-300 tw-cursor-pointer"
        [ngClass]="destacado ? 'tw-text-white' : 'tw-text-[#F67011]'"
      >
        <i class="bi bi-arrow-right tw-text-black tw-text-lg md:tw-text-xl"></i>
        <span>{{ buttonText }}</span>
      </button>
    </div>

  </div>
</div>
